{
  "email_unsubscribe": {
    "unsubscribe": "Unsubscribe",
    "confirm_title": "Unsubscribe",
    "confirm_content": "Are you sure you want to unsubscribe?",
    "its_official": "It's official",
    "unsubscribed_thanks": "You have unsubscribed. Thanks!",
    "all_communications": "all communications"
  },
  "campaign_templates": {
    "campaign_templates": "Campaign Templates",
    "new_template": "New Template",
    "template_title": "Template Title",
    "type_template_title": "Type Template Title",
    "save_as_template": "save as template",
    "rename_template": "Rename Template",
    "please_enter_title": "Please enter a title",
    "select_template_status": "select template status",
    "template": "Template",
    "first_name": "First name",
    "last_name": "Last name",
    "job_title": "Job title",
    "company_name": "Company name",
    "primary_email": "Primary email",
    "id": "Id"
  },
  "template_actions": {
    "template_actions": "template actions",
    "confirm_archive_title": "Are you sure you want to archive this template?",
    "confirm_archive_content": "Click confirm to archive",
    "confirm_clone_title": "Are you sure you want to clone this template?",
    "confirm_clone_content": "Click confirm to clone this template.",
    "confirm_restore_content": "Please confirm to restore template.",
    "confirm_restore_title": "Restore template?"
  },
  "campaigns": {
    "status": {
      "all": "All",
      "draft": "Draft",
      "scheduled": "Scheduled",
      "sending": "Sending",
      "sent": "Sent"
    },
    "filters": {
      "filter": "Filter",
      "clear_all": "Clear All",
      "created_by": "Created By",
      "created_at": "Created At",
      "scheduled_at": "Scheduled At",
      "sent_at": "Sent At",
      "workspaces": "Workspaces",
      "workspaces_tooltip": "Filter by Workspaces or Apps that you have access to",
      "show_filters": "show filters",
      "filters_active": "{{count}} filters are active",
      "search_employees": "start typing to search for employees",
      "search_workspace": "Search Workspace",
      "type_email_search": "Type email to search",
      "from": "From",
      "to": "To",
      "validation_date_range": "Please select both a start date and an end date"
    },
    "actions": {
      "send_now": "Send Now",
      "cancel_schedule": "Cancel Schedule",
      "save_as_template": "Save as Template",
      "clone": "Clone",
      "ok": "Ok",
      "campaign_actions": "campaign actions",
      "done": "Done",
      "preview": "Preview",
      "get_form_link": "Get form link"
    },
    "messages": {
      "send_now_header": "Send the campaign now?",
      "send_now_caption": "Once sent, the campaign cannot be canceled or revoked. Are you sure you want to proceed?",
      "cancel_schedule_title": "Cancel the scheduled campaign?",
      "cancel_schedule_content": "We will move this campaign to the Drafts tab.",
      "cancel_success": "Your scheduled campaign has been successfully canceled.",
      "cancel_error": "Campaign cancellation failed. Refresh and attempt again."
    },
    "headers": {
      "all_campaigns": "All Campaigns",
      "new_campaign": "New Campaign",
      "templates": "Templates"
    },
    "tooltips": {
      "continuous_sending": "Allowed continuous sending"
    }
  },
  "campaign": {
    "clone": {
      "confirm_title": "Are you sure you want to clone this campaign?",
      "confirm_content": "Click confirm to clone this campaign."
    },
    "add_recipient": {
      "modal_title": "Add New Recipient",
      "email_label": "Email",
      "email_placeholder": "Enter email",
      "send_scheduled": "Send as Scheduled",
      "send_now": "Send now",
      "placeholder": "Type recipient email to send the campaign..."
    },
    "analytics": {
      "activities": "Activities",
      "clear_selection": "Clear selection",
      "log_new_activity": "Log New Activity",
      "contact": "Contact",
      "company": "Company",
      "location": "Location",
      "last_interaction": "Last Interaction",
      "latest_status": "Latest Status",
      "add_to_list": "Add to list",
      "add_tags": "Add tags",
      "log_new_activity_action": "Log new activity"
    },
    "filters": {
      "filter": "Filter",
      "delivery_status": "Delivery Status",
      "clicked_link": "Clicked Link",
      "clear_all": "Clear All",
      "select_status": "Select Status",
      "marked_as_spam": "Marked as spam",
      "filters_active": "filters are active",
      "show_filters": "show filters",
      "select_delivery_status": "select delivery status"
    },
    "status": {
      "draft": "Draft",
      "scheduled": "Scheduled",
      "sending": "Sending",
      "archived": "Archived",
      "sent": "Sent",
      "unknown": "Unknown"
    },
    "content": {
      "details": "Details",
      "subject": "Subject",
      "from": "From",
      "recipients": "Recipients",
      "attachment": "Attachment",
      "content": "Content",
      "campaign_content": "Campaign content",
      "iframe_not_supported": "Your browser does not support iframes.",
      "add_new_recipient": "Add new recipient",
      "analytics": "Analytics"
    },
    "update": {
      "details": "Details",
      "subject_placeholder": "Enter the campaign subject",
      "from": "From",
      "recipient_list": "Recipient List",
      "attachment": "Attachment",
      "no_campaign_data": "No campaign data",
      "content": "Content",
      "select_template": "Select Template",
      "remove": "Remove",
      "campaign_email_template": "Campaign email template",
      "iframe_not_supported": "Your browser does not support iframes.",
      "select_sender": "Select Sender",
      "search_list": "Search for a list"
    },
    "remove_content": {
      "confirm_title": "Are you sure you want to remove this content?",
      "confirm_content": "Click the confirm button to remove"
    },
    "settings": {
      "header": "Settings",
      "button": "SETTINGS",
      "continuous_sending": "Allow continuous sending",
      "continuous_sending_caption": "You can add additional participant after the campaign is sent",
      "resend_existing": "Allow to resend to existing recipients",
      "resend_existing_caption": "Recipients may receive this campaign more than once.",
      "click_tracking": "Click Tracking",
      "click_tracking_caption": "Monitors the links within an email and records when recipients click on them",
      "open_tracking": "Open Tracking",
      "open_tracking_caption": "Tracks when an email is opened by the recipient"
    },
    "warning": {
      "all_set": "All set",
      "high_risk_removed": "Any high-risk email will be removed from the campaign recipients.",
      "view_list": "View List",
      "clean_list": "Clean List",
      "cleaning_in_progress": "List Cleaning is in progress"
    },
    "attachment": {
      "cannot_delete": "Cannot delete:",
      "cannot_upload": "Cannot upload:"
    },
    "create": {
      "header": "New Email Campaign",
      "name_label": "Name",
      "name_placeholder": "Name",
      "name_required": "please enter a name",
      "create_button": "Create Campaign"
    },
    "template": {
      "select": "Select {{title}}",
      "first_name": "First name",
      "last_name": "Last name",
      "job_title": "Job title",
      "company_name": "Company name",
      "primary_email": "Primary email",
      "id": "Id"
    },
    "actions": {
      "send_test": "Send Test"
    },
    "archive": {
      "confirm_title": "Are you sure you want to archive this campaign?",
      "confirm_content": "Click confirm to archive this campaign."
    },
    "select": {
      "placeholder": "Choose Campaign"
    },
    "add_to_campaign": {
      "header": "Add to Campaign",
      "select_campaign": "Select Campaign",
      "confirm_title": "Proceed with Add to Campaign?",
      "caption": "You can add additional recipients to continuous email campaigns type.",
      "contact": "contact",
      "contacts": "contacts",
      "confirm_content": "Are you sure you want to add {{count}} {{contactCountText}} to the \"{{campaignTitle}}\"?",
      "warning": "This will trigger the email campaign immediately and cannot be undone"
    },
    "test_email": {
      "send_test": "Send Test",
      "header": "Send Test Email",
      "caption": "Type recipient email to send the campaign. Once sent, it cannot be recalled or modified.",
      "email_label": "Email",
      "email_placeholder": "Enter email",
      "email_required": "Please enter a valid email"
    },
    "email_template": {
      "title": "Campaign email template",
      "iframe_not_supported": "Your browser does not support iframes.",
      "wrong_url": "looks like you got the wrong url."
    },
    "schedule": {
      "send_now": "Send Now",
      "time_zone": "Time Zone",
      "select_timezone": "Select timezone",
      "schedule_time": "Schedule Time",
      "schedule": "Schedule",
      "clean_list_header": "Clean the list",
      "clean_list_caption": "Please validate email addresses to ensure accuracy before sending campaigns. We will remove high risk email automatically if you clean the list. Skip to proceed without cleaning.",
      "send_campaign_now": "Send the campaign now?",
      "schedule_campaign_header": "Schedule Campaign",
      "send_now_caption": "Once sent, the campaign cannot be canceled or revoked. Are you sure you want to proceed?",
      "schedule_campaign_caption": "You are about to schedule this campaign to be sent to recipients. Are you sure?"
    }
  },
  "exclusion": {
    "rules": {
      "page_description": "These rules determine which contacts or companies are excluded from marketing. The contacts may be added to marketing lists and will be flagged for review.",
      "tabs": {
        "companies": "Companies",
        "contacts": "Contacts"
      },
      "form": {
        "header": "Exclude",
        "edit_header": "Edit",
        "caption": "Set rules to flag and exclude specific contacts or companies in Marketing List",
        "exclusion_type_label": "Exclusion Type",
        "applies_to_label": "Applies To",
        "marketing_category_label": "With Marketing Category Type",
        "company_name_label": "Company Name",
        "reason_label": "Reason",
        "reason_placeholder": "Type reason",
        "select_field_label": "Select Field",
        "select_field_placeholder": "Select Custom Field",
        "value_label": "Value",
        "value_placeholder": "Select Field Options",
        "company_placeholder": "Type to search company"
      },
      "types": {
        "block": "Block",
        "block_description": "Block - Prevent contacts from being added to lists and remove existing ones",
        "warn_description": "Warning - Allow to add to list but show warning"
      },
      "table": {
        "headers": {
          "exclusion_type": "Exclusion Type",
          "reason": "Reason",
          "fields": "Fields",
          "values": "Values",
          "marketing_categories": "Marketing Categories",
          "created_date": "Created Date",
          "created_by": "Created by",
          "company": "Company",
          "added_date": "Added Date",
          "added_by": "Added by"
        }
      },
      "actions": {
        "edit": "Edit",
        "delete": "Delete",
        "view_contacts": "View Contacts"
      },
      "confirmations": {
        "delete_contact_rule_title": "Are you sure you want to delete this rule?",
        "delete_contact_rule_content": "All contacts and companies connected to this rule will be removed from the exclusion list.",
        "delete_company_title": "Remove from this list?",
        "delete_company_content": "By removing from this list, any campaigns can be sent to this company."
      },
      "validation": {
        "select_exclusion_type": "Please select an exclusion type",
        "select_type": "Please select a type",
        "enter_reason": "Please enter a reason",
        "choose_category": "Please choose at least one category",
        "select_company": "Please select a company",
        "select_custom_field": "Please select a custom field",
        "select_option": "Please select at least one option",
        "select_value": "Please select a value"
      }
    },
    "list": {
      "header": "Marketing Exclusion",
      "description": "These companies have been excluded from marketing. You may still add contacts from excluded companies on marketing lists. We will warn users about marketing to these contacts. Please contact your admin for more info.",
      "all_categories": "All",
      "category_placeholder": "Category",
      "more_categories": "+{{count}} more",
      "add_company": {
        "button": "Exclude Company",
        "header": "Exclude Company",
        "company_name_label": "Company Name",
        "marketing_categories_label": "Marketing Categories"
      }
    },
    "types": {
      "select_placeholder": "Select Exclusion Type"
    }
  }
}
